import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAxios from 'vue-axios'
import axios from 'axios'
import moment from 'moment'
import 'animate.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import 'vant/lib/index.less';
import { Locale } from 'vant';
import zhTW from 'vant/es/locale/lang/zh-TW';
Locale.use('zh-TW', zhTW);
import { Lazyload } from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import '@vant/touch-emulator';

import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin);


Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;
Vue.use(ElementUI);
Vue.use(Lazyload);
Vue.use(VueAxios, axios)
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Vant);


//專案用vue mixin
import vueBase from './mixin/vueBase.js'
import vueApi from './mixin/vueApi.js'
import vueApp from './mixin/vueApp.js'
Vue.mixin(vueBase);
Vue.mixin(vueApi);
Vue.mixin(vueApp);


import Header from "./components/Index/Popup/Header"
import Footer from "./components/Index/Popup/Footer"
import FrmItemDetail from "./components/Index/Popup/FrmItemDetail"
import FrmItemDetailGroup from "./components/Index/Popup/FrmItemDetailGroup"
import ItemGroups from './components/Index/Popup/Child/ItemGroups';
import Stepper from "./components/Index/Popup/Child/Stepper"
import OCheck from './components/Index/Popup/FrmOCheck';
import Welcome from './components/Index/Popup/FrmWelcome';
import Car from './components/Index/Popup/FrmCar';
import MenuLR from './components/Index/MenuLR/MenuLR';
import MenuTB from './components/Index/MenuTB/MenuTB';
import FrmMore from './components/Index/Popup/FrmMore';
import FrmInputCustCount from './components/Index/Popup/FrmInputCustCount.vue';
Vue.component('More', FrmMore); //數量控組組件

import FrmServiceType from './components/Index/Popup/FrmServiceType';
Vue.component('ServiceType', FrmServiceType); //數量控組組件

import Enter from './components/Index/Popup/FrmEnter';
Vue.component('Enter', Enter); //選擇內用外帶

import FrmPoH from './components/Index/Popup/FrmPoH';
Vue.component('PoH', FrmPoH); //訂單主檔

import FrmPoI from './components/Index/Popup/FrmPoI';
Vue.component('PoI', FrmPoI); //訂單主檔

import FrmTimeTip from './components/Index/Popup/FrmTimeTip.vue';
Vue.component('FrmTimeTip', FrmTimeTip); //訂單主檔

// import FrmMenu from './views/Index/FrmMenu';
// Vue.component('Menu', FrmMenu); //選擇內用外帶



Vue.component('MenuTB', MenuTB); // 上下版型菜單
Vue.component('MenuLR', MenuLR); // 左右版型菜單
Vue.component('OCheck', OCheck); // 帳單頁
Vue.component('Welcome', Welcome); // 歡迎頁
Vue.component('Car', Car); //購物車頁
Vue.component('Header', Header); //天
Vue.component('Footer', Footer); //地
Vue.component('FrmItemDetail', FrmItemDetail); //項目主頁
Vue.component('FrmItemDetailGroup', FrmItemDetailGroup); //項目群組頁(可遞迴呼叫)
Vue.component('ItemGroups', ItemGroups); //群組組件(放置於主頁&群組頁)
Vue.component('Stepper', Stepper); //數量控組組件
Vue.component('FrmInputCustCount', FrmInputCustCount); //客數輸畫面


// import VueQrcode from 'vue-qrcode'

// Vue.component('VueQrcode', VueQrcode); //客數輸畫
// import VueQr from 'vue-qr'

Vue.component('VueQr', VueQr); //客數輸畫
import VueQr from 'vue-qr'

//封裝好的vant組件
// import NumPicker from './components/Vant/FrmNumPicker.vue';
// import DataPicker from './components/Vant/FrmDataPicker.vue';
// import CheckboxPicker from './components/Vant/FrmCheckboxPicker.vue';
// import RadioPicker from './components/Vant/FrmRadioPicker.vue';
// import DatePicker from './components/Vant/FrmDatePicker.vue';
// import CalendarPicker from './components/Vant/FrmCalendarPicker.vue';
// import Collapse from './components/Vant/Collapse.vue';
// import Popover from './components/Vant/Popover.vue';
// // import NavBar from '@/components/NavBar.vue';
// Vue.component('NumPicker', NumPicker);
// Vue.component('DataPicker', DataPicker);
// Vue.component('DatePicker', DatePicker);
// Vue.component('CheckboxPicker', CheckboxPicker);
// Vue.component('RadioPicker', RadioPicker);
// Vue.component('CalendarPicker', CalendarPicker);
// Vue.component('Collapse', Collapse);
// Vue.component('Popover', Popover);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')